module.exports = __webpack_public_path__ + "img/87aafe4.png";